import { createContext, useContext, useEffect, useMemo, useState } from "react";
import en from "./en";
import ar from "./ar";
import de from "./de";
import ru from "./ru";
import hi from "./hi";

const dictionaries = { en, ar, de, ru, hi };
const RTL_LANGS = new Set(["ar"]);
export const LANGUAGE_OPTIONS = [
  { code: "en", label: "EN", name: "English" },
  { code: "ar", label: "عربي", name: "العربية" },
  { code: "de", label: "DE", name: "Deutsch" },
  { code: "ru", label: "RU", name: "Русский" },
  { code: "hi", label: "हिं", name: "हिंदी" },
];

const detectLanguage = () => {
  try {
    const saved = localStorage.getItem("aa_lang");
    if (saved && dictionaries[saved]) return saved;
  } catch (e) {
    /* ignore */
  }
  return "en";
};

const lookup = (dict, path) =>
  path.split(".").reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), dict);

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(detectLanguage);
  const isRtl = RTL_LANGS.has(lang);

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = isRtl ? "rtl" : "ltr";
    try {
      localStorage.setItem("aa_lang", lang);
    } catch (e) {
      /* ignore */
    }
  }, [lang, isRtl]);

  const value = useMemo(
    () => ({
      lang,
      setLang,
      isRtl,
      t: (path) => lookup(dictionaries[lang], path) ?? lookup(en, path) ?? path,
    }),
    [lang, isRtl]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => useContext(LanguageContext);
